import { DropActionMenu } from "./DropActionMenu";
import tw from "twin.macro";

import { css } from "@emotion/css";
import { useObservableState } from "observable-hooks";
import React from "react";
import SplitPane from "react-split-pane";
import { GlobalStyles } from "twin.macro";
import { Calendar } from "./calendar/Calendar";
import { EntryScreen } from "./EntryScreen";
import { NoteRightClickMenu } from "./NoteRightClickMenu";
import { UndoSnackbar } from "./Snackbar";
import { authQuery } from "./state/state/authStore";
import { Sidebar } from "./view/Sidebar";
import Crisp from "./Crisp";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";

function App() {
  const auth$ = authQuery.select();
  const authLoading$ = authQuery.selectLoading();
  const authError$ = authQuery.selectError();

  const authLoading = useObservableState(authLoading$);
  const auth = useObservableState(auth$);

  if (authLoading === undefined || authLoading) {
    return <h3>Loading...</h3>;
  }

  if (auth?.uid === undefined) {
    return <EntryScreen />;
  }

  return (
    <>
      <BrowserView>
        <div
          className={css`
            height: 100vh;
            display: flex;
            flex-direction: column;
          `}
        >
          <UndoSnackbar />
          <Crisp />
          <GlobalStyles />
          <div
            className={css`
              position: relative;
              flex-grow: 1;
            `}
          >
            <SplitPane
              split="vertical"
              minSize={280}
              maxSize={800}
              defaultSize={420}
            >
              <Sidebar />
              <Calendar />
            </SplitPane>
          </div>
          <DropActionMenu />
          <NoteRightClickMenu />
        </div>
      </BrowserView>
      <MobileView>
        <h3>Sorry, the Todoyogi app is only available on desktop for now :(</h3>
      </MobileView>
    </>
  );
}

export default App;

export function Logo() {
  return (
    <div
      className={css`
        display: flex;
        place-items: center;
        place-content: start;
        height: 100%;
      `}
    ></div>
  );
}
